// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__1aa56","Win":"styles_Win__2ox4t","Lose":"styles_Lose__5tYHt","Draw":"styles_Draw__F5_02"};